import {Hr, Text} from '@constellation/core';
import {Phone} from '@constellation/core/icons';
import {Box} from '../../../../common/Analytics/Tagging/index.js';

type CallToActionInterface = {
  heading: string;
  availabilitynote: string;
  phonenumber: string;
  taggingLabel: string;
};

const CallToActionBox = ({
  heading,
  availabilitynote,
  phonenumber,
  taggingLabel,
}: CallToActionInterface) => (
  <Box bgColor='brand2' taggingLabel={taggingLabel}>
    <Phone aria-label='Call' iconSize='lg' trim={true} />
    <Text data-test-id='card-payment' marginLeft='04' size='s4'>
      {heading}
    </Text>
    <Hr marginBottom='04' marginTop='04' />
    <Text size='s4'>{phonenumber}</Text>
    <br />
    <Text size='s2'>{availabilitynote}</Text>
  </Box>
);

export default CallToActionBox;
